import { motion } from 'framer-motion'
import { GradientBackground } from './GradientBackground'
import { useProjects } from '../hooks/useProjects'

const allImages = [
  '/assets/projects/tribute-discovery-daft-punk/coverlg.jpg',
  '/assets/projects/tribute-discovery-daft-punk/interstella5555_copertina.jpg',
  '/assets/projects/tribute-discovery-daft-punk/DaftPunk_ClassicLogoTee_Detail.webp',
  '/assets/projects/tribute-discovery-daft-punk/banner_interstella.avif',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 16.25.39.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 22.18.58.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 22.27.15.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 22.40.43.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 22.45.26.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 23.05.16.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-15 alle 23.05.53.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 11.46.14.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 11.46.20.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 11.46.38.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 11.47.02.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 11.47.09.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 12.47.24.png',
  '/assets/projects/tribute-discovery-daft-punk/Screenshot 2024-12-16 alle 12.47.41.png',
]

export function ProjectDaftPunk() {
  const { getRandomProject } = useProjects()
  
  const handleNextProject = () => {
    const randomProject = getRandomProject('tribute-discovery-daft-punk')
    if (randomProject) {
      window.location.hash = randomProject.slug
    }
  }
  
  return (
    <GradientBackground>
      {/* Hero Section - Video */}
      <section className="relative h-[65vh] w-full">
        <video 
          src="/assets/projects/tribute-discovery-daft-punk/wip_daft.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
          poster="/assets/projects/tribute-discovery-daft-punk/interstella5555_copertina.jpg"
        />
      </section>

      {/* Project Info */}
      <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, transparent 0%, #CFCFCF 100%)' }}>
        <div className="container mx-auto max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
          >
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Client</h3>
              <p className="text-lg font-medium text-white">Personal Project</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Services</h3>
              <p className="text-lg font-medium text-white">Motion Design, 3D</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Year</h3>
              <p className="text-lg font-medium text-white">2024</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Project</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              A tribute project celebrating Daft Punk's iconic album "Discovery". 
              This project explores the visual universe of the French electronic music duo 
              through motion graphics, 3D renders, and video editing. The work pays homage 
              to the iconic aesthetic of Interstellar 5555 and the legendary helmet designs.
            </p>

            {/* Images Grid - 2 columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              {allImages.map((src, index) => (
                <motion.img
                  key={src}
                  src={src}
                  alt={`Daft Punk ${index + 1}`}
                  className="w-full rounded-lg shadow-lg"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  loading="lazy"
                />
              ))}
            </div>

            {/* Video Section - 65% width, loop without controls */}
            <div className="mb-16 flex justify-center">
              <video 
                src="/assets/projects/tribute-discovery-daft-punk/0001-0240.mp4"
                autoPlay
                muted
                loop
                playsInline
                className="w-[65%] rounded-lg shadow-lg"
              />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Navigation Footer */}
      <section className="py-16 px-4 bg-[#CFCFCF]">
        <div className="container mx-auto max-w-4xl">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/#works"
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105"
              style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              <span className="relative z-10">← Back to Works</span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </a>
            <button 
              onClick={handleNextProject}
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105"
              style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              <span className="relative z-10">Next Project →</span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </section>
      
      <style>{`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </GradientBackground>
  )
}
